<template>
    <div class="person-info">
        <div class="header-wrap">
            <img @click="uploadHeadImg"  :src="profileInfo.headImgUrl || defaultHeadImg" alt="" class="header-icon">
            <div class="account">{{profileInfo.nickName}}</div>
            <uploadFiles ref="uploadFile" :multiple="isMultiple" type="用户头像"  @updateTotalImgList="updateHeadImg($event)"></uploadFiles>
        </div>
        <div class="form-group-wrap">
            <div class="form-group" >
                <div class="form-group-name">基本信息</div>
                <div class="form-item" >
                    <div class="left-label">用户名</div>
                    <div class="show-group group" v-if="formStatus.nickName=='show'">
                        <div class="text">{{profileInfo.nickName}}</div>
                        <Button class="edit" type="info" size="large" @click="modify('nickName')">修改</Button>
                    </div>
                    <div  class="edit-group group" v-else>
                        <input class="form-input" ref="nickNameInput" v-model.trim="profileInfo.nickName" type="text" placeholder="用户账户" >
                        <div class="btn-group">
                            <Button type="dashed" size="large" class="cancelSave" @click="cancelSave('nickName')">取消</Button>
                            <Button type="success" size="large" class="save" @click="save('nickName')">保存</Button>
                        </div>
                    </div>
                </div>
                <!--<div class="form-item" >-->
                    <!--<div class="left-label">邮箱</div>-->
                    <!--<div class="show-group group" v-if="formStatus.mail=='show'">-->
                        <!--<div class="text">{{profileInfo.mail}}</div>-->
                        <!--<Button type="info" class="edit" size="large" @click="modify('mail')">修改</Button>-->
                    <!--</div>-->
                    <!--<div  class="edit-group group" v-else>-->
                        <!--<input class="form-input" v-model.trim="profileInfo.mail" type="email" placeholder="个人邮箱" >-->
                        <!--<div class="btn-group">-->
                            <!--<Button type="dashed" size="large" class="cancelSave" @click="cancelSave('mail')">取消</Button>-->
                            <!--<Button type="success" size="large" class="save" @click="save('mail')">保存</Button>-->
                        <!--</div>-->
                    <!--</div>-->
                <!--</div>-->
                <!--<div class="form-item" >-->
                    <!--<div class="left-label">手机号码</div>-->
                    <!--<div class="show-group group" v-if="formStatus.phone=='show'">-->
                        <!--<div class="text">{{profileInfo.phone}}</div>-->
                        <!--<Button type="info" size="large" class="edit" @click="modify('phone')">修改</Button>-->
                    <!--</div>-->
                    <!--<div  class="edit-group group" v-else>-->
                        <!--<input class="form-input" v-model.trim="profileInfo.phone" type="number" placeholder="请输入手机号码" >-->
                        <!--<div class="btn-group">-->
                            <!--<Button type="dashed" size="large" class="cancelSave" @click="cancelSave('phone')">取消</Button>-->
                            <!--<Button type="success" size="large" class="save" @click="save('phone')">保存</Button>-->
                        <!--</div>-->
                    <!--</div>-->
                <!--</div>-->
            </div>
            <div class="form-group" >
                <div class="form-group-name">账户安全</div>
                <div class="form-item" >
                    <div class="left-label">登录密码</div>
                    <div class="show-group group" v-if="formStatus.pwd=='show'">
                        <Button type="info" size="large" class="edit" @click="modify('pwd')">修改</Button>
                    </div>
                    <div  class="edit-group group" v-else>
                        <div>
                            <input class="form-input" ref="oldPwdInput" v-model.trim="oldPwd" type="password" placeholder="请输入原账户密码" >
                            <br><br>
                            <input class="form-input" ref="newPwdInput" v-model.trim="newPwd" type="password" placeholder="请输入新账户密码" >
                            <br><br>
                            <input class="form-input" ref="enteredPwdInput" v-model.trim="enteredPwd" type="password" placeholder="请再输入新账户密码" >
                        </div>
                        <div class="btn-group">
                            <Button type="dashed" size="large" class="cancelSave" @click="cancelSave('pwd')">取消</Button>
                            <Button type="success" size="large" class="save" @click="changePwd">保存</Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    var self ;
    import api from '../../api/api'
    import uploadFiles from '../../components/uploadFiles'
    export default {
        components: {
            uploadFiles
        },
        data(){
            return{
                id:'',
                isMultiple:false,
                openid:'',
                defaultHeadImg:require('../../assets/images/defaultHeadimg.jpeg'),
                profileInfo:{
                    nickName:'',
                    // sex:'',
                    // phone:'',
                    headImgUrl:''
                },
                formStatus:{
                    nickName:'show',
                    // sex:'show',
                    // mail:'show',
                    // phone:'show',
                    pwd:'show'
                },
                oldPwd:'',
                newPwd:'',
                enteredPwd:''
            }
        },
        activated(){
            self = this;
            this.getProfileInfo();
        },
        methods:{
            uploadHeadImg(){
                this.$refs.uploadFile.uploadPic()
            },
            //更新头像的url
            updateHeadImg(items){
                if(items.length==0){
                    this.profileInfo.headImgUrl = '';
                }else {
                    this.profileInfo.headImgUrl = items[0].url
                }
                api.updateUserInfo({headImgUrl:this.profileInfo.headImgUrl}).then(res =>{
                    self.$Message.success(`头像修改成功！`)
                }).catch(error =>{
                    self.$Message.error(`头像修改失败！`)
                })
            },
            getProfileInfo(){
                api.getProfileInfo().then(res =>{
                    self.profileInfo = res
                    self.headImgUrl = res.headImgUrl
                    self.id = res.id;

                    if (res.extend && res.extend.memorialId) {
                        self.$store.state.userMemorialId = res.extend.memorialId
                    }
                }).catch(error =>{
                    self.$Message.error(error.info ||'获取信息失败')
                    setTimeout(function () {
                        self.$emit('toLogOut')
                    },500)
                });
            },
            changePwd(){
                if(!this.oldPwd){
                    self.$Message.error(`请输入原账户密码！`)
                    self.$refs.oldPwdInput.focus()
                    return
                }
                if(!this.newPwd){
                    self.$Message.error(`请输入新账户密码！`)
                    self.$refs.newPwdInput.focus()
                    return
                }
                if(!this.enteredPwd){
                    self.$Message.error(`请输入再次输入新账户密码！`)
                    self.$refs.enteredPwdInput.focus()
                    return
                }
                if(this.enteredPwd != this.newPwd){
                    self.$Message.error(`两次输入的密码不一致请重新输入！`)
                    self.$refs.newPwdInput.focus()
                    return
                }
                this.formStatus.pwd='show'
                var data = {
                    oldPwd:this.oldPwd,
                    newPwd:this.newPwd
                }
                api.updatePwd(data).then(res =>{
                    self.$Message.success(`修改成功！`)
                }).catch(error =>{
                    self.$Message.error(`修改失败！${error.info}`)
                })
            },
            modify(key){
                this.formStatus[key]='modify'
            },
            cancelSave(key){
                this.formStatus[key]='show'
            },
            save(key){
                if(key=='nickName'){
                    if(!this.profileInfo.nickName){
                        self.$Message.error(`用户名不能为空！`)
                        self.$refs.nickNameInput.focus()
                        self.getProfileInfo()
                        return
                    }
                }
                this.formStatus[key]='show'
                api.updateUserInfo(this.profileInfo).then(res =>{
                    self.$Message.success(`修改成功！`)
                }).catch(error =>{
                    self.$Message.error(`修改失败！${error.info}`)
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    button.edit{
        background-color: #009DE9;
    }
    .person-info{
        padding: 50px 70px;
        .header-wrap{
            position: relative;
            text-align: center;
            display: inline-block;
            width: 100px;
            height: 100px;
            .header-icon{
                width: 100%;
                height: 100%;
                border-radius: 50%;
            }
            .account{
                font-size: 16px;
                color: #000;
            }
            .upload-files-wrap{
                position: absolute;
                left: 340px;
                top: 20px;
                opacity: 0;
                z-index: -1;
            }
        }
        .form-group-wrap{
            margin-top: 50px;
            font-size: 16px;
            color: #333;
            .form-group{
                margin-bottom: 50px;
                .form-group-name{
                    text-align: left;
                    font-size: 18px;
                    border-bottom: 1px solid #e5e5e5;
                    padding-bottom: 20px;
                    margin-bottom: 30px;
                }
                .form-item{
                    overflow: hidden;
                    border-bottom: 1px solid #e5e5e5;
                    padding-bottom: 10px;
                    margin-bottom: 10px;
                    line-height: 40px;
                    padding-left: 100px;
                    .left-label{
                        float: left;
                        width: 100px;
                        text-align: left;
                        margin-left: -100px;
                    }
                    .group{
                        width: 100%;
                        float: left;
                        .form-input{
                            float: left;
                            border-radius: 4px;
                            /*border: none;*/
                            width: 300px;
                            height: 40px;
                            padding: 5px;
                        }
                        .edit{
                            float: right;
                            &:hover{
                                cursor: pointer;
                            }
                        }
                        .btn-group{
                            float: right;
                        }
                        .save{
                            float: left;
                            &:hover{
                                cursor: pointer;
                            }
                        }
                        .cancelSave{
                            float: left;
                            margin-right: 20px;
                            &:hover{
                                cursor: pointer;
                            }
                        }
                        &.show-group{

                            .text{
                                float: left;
                                display: inline-block;
                                width: 300px;
                                text-align: left;
                            }
                        }
                        &.edit-group{

                        }
                    }

                }
            }
        }
    }
</style>
